
<template>
  <div class="background">
    <div class="main">
      <div class="content">
       <!--  <div class="vip-options">
          <div class="vip-item" v-for="item in options" :key='item'  :class="{active:item.pic==pic}"
               @click="handleClickUpdateOrder(item.pic,item.value)">
            <p class="pic">¥<span> {{item.pic}} </span>/ {{item.time}}</p>
            <p class="text">{{item.text}}</p>
          </div>
        </div> -->
        <div class="title">优惠券</div>
        <div class="coupons-main" :class="{'has-list':couponsList.length}">
          <div class="coupons-header">
            <input placeholder="请输入兑换码" class="coupons-input" v-model="couponsText"/>
            <div class="coupons-submit" @click="handleClickSubmit">兑换</div>
          </div>

          <div class="coupons-list" v-if="couponsList.length">
            <div class="page left" @click.stop="handleClickTo(1)" v-show="couponsList.length>1&&couponsIndex!=0">
              <i class="iconfont iconchevron-left"></i>
            </div>
            <div class="page right" @click.stop="handleClickTo(-1)"
                 v-show="couponsList.length>1&&couponsIndex!=-(couponsList.length-1)">
              <i class="iconfont iconchevron-right"></i>
            </div>

            <div class="list-container" v-for="(list,index) in couponsList" :key="index" :style="{transform:`translateX(${couponsIndex*460}px)`}">
              <div class="list-item" v-for="item in list" :key='item.id' :class="{'active':item.id == couponsToken}"
                   @click="handleClickSelectCoupons(item)">
                <div class="item-pic" v-if="item.cent">¥ <span>{{item.cent/100}}</span></div>
                <div class="item-pic" v-if="item.discount"><span>{{item.discount * 10}}折</span></div>
                <div class="item-pic" v-if="item.member_days"><span>{{item.member_days}}天</span></div>
                <div class="item-text-time">
                  <p>{{item.name}}</p>
                  <p>有效期：{{ moment(item.expiry).format('YYYY-MM-DD') }}</p>
<!--                  <p>有效期：{{item.expiry.slice(0,10)}}</p>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="button">
            <button class="cancel" @click="close">取消</button>
            <button class="confirm" @click="couponPrice">使用</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from "vuex"
  import moment from "moment"
  import qrcodeVue from 'qrcode-vue';
  import api from "../../../api";
  import {get_tUser, routerTo} from "@/assets/js/util"

  export default {
    props: {
      activePic: {
        type: Number,
        default: 19
      },
      orderId: {
        type: String
      },
      couponId: {
        type: Number,

      },
      plan: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        moment,
        couponsDuiHuan:'',
        //优惠券列表
        couponsList: [],
        //优惠券左移右移下标
        couponsIndex: 0,
        //价格
        pic: 19,
        //优惠券价格
        couponsPic: 0,
        //优惠券id
        couponsToken: '',
        //优惠券兑换码
        couponsText: "",
        //点击支付时状态（做假节流）
        isPayLoading: false,
        host: "",//域名
        isShowBtn: false,
        isError: false,
        timer: null,//轮训定时器
        isShowError: false
      }
    },
    computed: {
      ...mapState("me", ["personInfo"])
    },
    components: {
      qrcodeVue
    },
    async created() {
      let data = {}
      if (this.plan === 'intern') {
        data.coupon_plan = '实习版'
      }else if (this.plan === 'campus') {
        data.coupon_plan = '校招版'
      }else if (this.plan === 'full') {
        data.coupon_plan = '全职版'
      }
      let res = await api.account.getSpecialOffers(get_tUser().c_t, data)
      let {code, data: {coupons}} = res
      if (code === 1000) {
        coupons = coupons.filter(item => item.usable)
        for (let i = 0; i < coupons.length; i += 2) {
          this.couponsList.push(coupons.slice(i, i + 2));
        }
      }
      setTimeout(() => {
        this.isShowBtn = true
      }, 3000)
      this.couponsToken = this.couponId
    },
    async mounted() {
      document.body.style.overflow = 'hidden'
      this.timer = setInterval(() => {
        //this.checkOrder()
      }, 3000)
    },
    methods: {
      ...mapActions('me', ['getUserInfo']),
      async close() {
        await this.getUserInfo()
        document.body.style.overflow = 'visible'
        this.$emit("close")
      },
      handleClickTo(value) {
        this.couponsIndex += value
      },
      //修改价格更新订单
      async handleClickUpdateOrder(pic, value) {
        this.pic = pic
        let res = await api.account.updateOrder(this.orderId, {member_period: value})
        if (res.code === 600205) {
          this.$message.error(res.message)
          this.pic = res.data.price
        }
      },
      //选择优惠券
      handleClickSelectCoupons(obj) {
        this.couponsToken = obj.id;
        this.couponsDuiHuan = obj;
        this.$emit('getCouponId',this.couponsToken,this.couponsDuiHuan)
        // this.couponsPic = cent / 100
        // if (this.couponsToken == id) {
        //   this.couponsToken = '';
        //   this.couponsPic = 0
        // } else {
        //   this.couponsToken = id;
        //   this.couponsPic = cent / 100
        // }
      },
      //提交兑换码
      async handleClickSubmit() {
        if (!this.couponsText) {
          this.$message.error("无效兑换码，请检查")
          return
        }
        let datas = {partner: this.couponsText}
        if (this.plan === 'intern') {
          datas.coupon_plan = '实习版'
        }else if (this.plan === 'campus') {
          datas.coupon_plan = '校招版'
        }else if (this.plan === 'full') {
          datas.coupon_plan = '全职版'
        }
        let createCoupons = await api.account.couponsCreate(get_tUser().c_t, datas)
        if (createCoupons.code === 1000) {
          this.$message.success(createCoupons.data.message);
          this.couponsList = []
          let coupons = createCoupons.data.coupons.filter(item => item.usable)
          for (let i = 0; i < coupons.length; i += 2) {
            this.couponsList.push(coupons.slice(i, i + 2));
          }

          //使用默认选中最新兑换的
          this.handleClickSelectCoupons(createCoupons.data.coupons[0]);
          this.couponsText = ""
        }else {
          this.$message.error(createCoupons.data ? createCoupons.data.error : createCoupons.message)
        }
      },
      // 派发事件
      couponPrice () {
        if(!this.couponsToken){
          this.$message.error("请选择优惠券")
          return
        }
        this.$emit('getCouponId',this.couponsToken,this.couponsDuiHuan)
        this.close()

      }
    },
    beforeDestroy() {
      clearInterval(this.timer)
    }
  }
</script>

<style scoped lang="scss">
  @import './counpons.scss';
</style>
